export default {
    '0000': 'Error, vuelve a subir el video',
    '0500': 'Error de conexión',
    'UPLOADING': 'Subiendo el video',
    'UPLOAD_COMPLETE': 'Subida completada',
}
